import React from 'react';
import { Link } from 'react-router-dom';
type LogoProps = {
  inverted?: boolean;
};
const logoSrc = 'https://cdn.magicpatterns.com/uploads/34Rx1bNpzDthHudAsMqUSZ/Logochbankf.png';
export function Logo({
  inverted = false
}: LogoProps) {
  return <Link to="/" aria-label="Chinguitty Bank — Accueil" className={`inline-flex shrink-0 items-center ${inverted ? 'rounded-2xl bg-white px-4 py-3' : ''}`} data-id="element-226" data-mp="tdwdrzqr5qr1">
      <img src={logoSrc} alt="Chinguitty Bank — مصرف شنقيط" className={inverted ? 'h-14 w-auto' : 'h-[60px] w-auto'} data-id="element-227" data-mp="kcodjc4oefub" />
    </Link>;
}